export const SORTING_PROFILES = {
    MORNING: 'Morning',
    LOCKER: 'Locker',
    DISTRIBUTION_HOME: 'Distribution Home',
    EVENING: 'Evening',
    RETURNS: 'Returns',
    ON_DEMAND_ROUTES: 'On Demand Routes',
}
